import React from 'react';

/**
 * Stepper NOMMÉ partagé des wizards livreur (Phase B). Remplace les points nus
 * `dw-dots` : pastille numérotée + libellé sous chaque étape, état courant /
 * franchi (✓) — même principe que le stepper du wizard commande (cw-stp), porté
 * ici avec les classes `dw-steps`/`dw-stp` (mêmes tokens --dw-*).
 *
 * `steps` reflète le flux RÉEL (dynamique) de CE wizard : les maillons sautés
 * (ex. « Prise » déjà faite, « Paiement » sans vente) ne sont pas passés, donc
 * le stepper ne montre que les étapes pertinentes — comme le faisaient les points.
 */
export default function WizardStepper({ steps, current }) {
  const cur = steps.findIndex((s) => s.key === current);
  return (
    <ol className="dw-steps" aria-label={`Étape ${Math.max(0, cur) + 1} sur ${steps.length}`}>
      {steps.map((s, i) => (
        <li key={s.key}
          className={`dw-stp${i === cur ? ' is-current' : ''}${i < cur ? ' is-done' : ''}`}
          aria-current={i === cur ? 'step' : undefined}>
          <span className="dw-stp__n" aria-hidden="true">{i < cur ? '✓' : i + 1}</span>
          <small>{s.label}</small>
        </li>
      ))}
    </ol>
  );
}
